// deps
import React, { memo, useState, useEffect, useRef } from "react";

//constants
import { LOTTIE_ANIMATIONS, LOTTIE_ANIMATIONS_CONGRATS_PROPS, AMOUNT_FORMAT } from "@dineout-cart-ui/constants/index";

// styles
import { AmountWrapper, AnimWrapper } from "./styles";
import { CongratsAnimationWrapper, TickerText } from "../payment-success-ticker/styles";

// components
import { PaymentSuccessTicker } from "../payment-success-ticker";

// internal deps
import { PAYMENT_SUCCESS_BANNER } from "@swiggy-private/payment-test-ids";
import { currencyFormat } from "@swiggy-private/dineout-payment-success-ui";
import { getCloudinaryUrl, LottieAnimation, format } from "@swiggy-private/core-ui";
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types";

interface DiscountAnimationProps {
    isDiscount: boolean;
    showAnimation: boolean;
    totalBillExcludingExtras: number;
    enteredAmount: number;
    isRewardRedeemed: boolean;
    shouldAnimate: boolean;
    redeemableRewards?: number;
    tickerTextColor?: keyof IColors;
}
const LOTTIE_ANIMATION_TIMEOUT = 350;
const DiscountWrapper: React.FC<DiscountAnimationProps> = (props: DiscountAnimationProps) => {
    const {
        isDiscount,
        showAnimation,
        totalBillExcludingExtras,
        enteredAmount,
        isRewardRedeemed,
        shouldAnimate,
        redeemableRewards,
        tickerTextColor = "positive_Sub",
    } = props;
    const [showLottie, setShowLottie] = useState(false);
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        if (isDiscount && showAnimation) {
            timerRef.current = setTimeout(() => {
                setShowLottie(true);
            }, LOTTIE_ANIMATION_TIMEOUT);
        } else {
            setShowLottie(false);
        }

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [isDiscount, showAnimation]);

    return isDiscount ? (
        <AnimWrapper>
            {showAnimation && showLottie && (
                <CongratsAnimationWrapper>
                    <LottieAnimation
                        {...LOTTIE_ANIMATIONS_CONGRATS_PROPS}
                        fileName={getCloudinaryUrl(LOTTIE_ANIMATIONS.CONGRATS_LOTTIE)}
                        visible={true}
                        playLottie={true}
                    />
                </CongratsAnimationWrapper>
            )}
            <PaymentSuccessTicker
                targetNumber={totalBillExcludingExtras}
                originalAmount={enteredAmount}
                showTickerAnimation={isDiscount && showAnimation}
                isRewardRedeemed={isRewardRedeemed}
                redeemableRewards={redeemableRewards}
                tickerTextColor={tickerTextColor}
            />
        </AnimWrapper>
    ) : (
        <AmountWrapper>
            <TickerText
                variant="V2.subheading1.neutral.bold"
                color="background_Primary"
                data-testid={PAYMENT_SUCCESS_BANNER.SAVING_DIGIT}
                isRewardRedeemed={isRewardRedeemed}
                shouldAnimate={shouldAnimate}
                tickerTextColor={tickerTextColor}
            >
                {format(AMOUNT_FORMAT, currencyFormat(totalBillExcludingExtras))}
            </TickerText>
        </AmountWrapper>
    );
};

export default memo(DiscountWrapper);
